import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
function Text({
  fontSize = "item",
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(TextStyled, {
    $fontSize: fontSize,
    ...props,
    children
  });
}
const TextStyled = styled.div.withConfig({
  displayName: "TextStyled",
  componentId: "sc-14qd6tq-0"
})(["", " padding:", " ", ";color:", ";"], (props) => props.$fontSize === "item" ? textStyles.uiTextS : textStyles.uiTextM, token.spacing3, token.spacing5, token.gray400);
export {
  Text
};
//# sourceMappingURL=Text2.js.map
